import ColorSchemesExample from "../../gear/navbar/BasicExample";
import React from "react";

import cover from "./cover.jpg";
import song from "./Khagall — 37 дней.mp3";

let Secret = () => {
    return (
        <>
            <ColorSchemesExample />

            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "80vh",
                    textAlign: "center"
                }}
            >
                <img
                    src={cover}
                    alt="center visual"
                    style={{
                        maxWidth: "400px",
                        width: "100%",
                        marginBottom: "20px",
                        borderRadius: "12px"
                    }}
                />

                <audio controls>
                    <source src={song} type="audio/mpeg" />
                    Your browser does not support the audio element.
                </audio>
            </div>
        </>
    );
};

export default Secret;